import { render, staticRenderFns } from "./checkRiskThree.vue?vue&type=template&id=5e6f224a&scoped=true&"
import script from "./checkRiskThree.vue?vue&type=script&lang=js&"
export * from "./checkRiskThree.vue?vue&type=script&lang=js&"
import style0 from "./checkRiskThree.vue?vue&type=style&index=0&id=5e6f224a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6f224a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6f224a')) {
      api.createRecord('5e6f224a', component.options)
    } else {
      api.reload('5e6f224a', component.options)
    }
    module.hot.accept("./checkRiskThree.vue?vue&type=template&id=5e6f224a&scoped=true&", function () {
      api.rerender('5e6f224a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/checkRiskThree.vue"
export default component.exports